const FeatureItem = ({ title, description, icon, href, external }) => (
  <a
    href={href}
    className="p-5 rounded-lg flex flex-col justify-start items-start gap-2 hover:bg-[#F3F4F8] cursor-pointer"
    rel={external ? 'nofollow' : undefined}
  >
    <div className="flex items-center gap-2">
      <div className="w-6 h-6">{icon}</div>
      <div className="mega-menu-submenu-title">{title}</div>
    </div>
    <div className="mega-menu-submenu-text">{description}</div>
  </a>
);

export default FeatureItem;
